import { createSurveyStyles } from '@sm/webassets';
import { responsiveMax } from '~app/helpers/responsive';

type SurveStyleNames =
  | 'surveyHeaderContainer'
  | 'surveyToolbarContainer'
  | 'surveyTitleContainer'
  | 'pageHeaderContainer'
  | 'layoutMainContainer'
  | 'questionContainer'
  | 'pageFooterContainer'
  | 'surveyFooterContainer'
  | 'pageNavigationContainer'
  | 'navButtons';

type SurveyStyleProps = { offsetTop: number };
const useStyles = createSurveyStyles<SurveStyleNames, SurveyStyleProps>({
  // Document banner container
  surveyHeaderContainer: {},
  // Exit-link container
  surveyToolbarContainer: {},
  // Survey Title container
  surveyTitleContainer: {},
  // Page Header container
  pageHeaderContainer: {},
  // Main container
  layoutMainContainer: {
    marginTop: ({ offsetTop }) => `${offsetTop}px`,
  },
  // Form
  questionContainer: {},
  // Page Footer Container
  pageFooterContainer: {},
  // May not be used
  surveyFooterContainer: {},
  // Page Navigation
  pageNavigationContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
  },

  // Page Navigation Buttons
  navButtons: {
    '&:not(:last-child):not(:only-of-type)': {
      marginRight: '5px',
    },
    // TODO: use breakpoints from theme; remove dependency from util method
    // if only one button, expand to fill <= 480px
    ...responsiveMax(480, {
      '&:only-of-type': {
        width: '100%',
      },
    }),
  },
});

export default useStyles;
